<template>
  <zm-modal
    @ok="handleSubmit"
    :title="title"
    :width="width"
    :visible="visible"
    size="large"
    @cancel="open(false)"
    :footer="footer"
  >
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名" hasFeedback>
              <a-input id="name" autocomplete="off" :allowClear="true" :disabled="isEdit" v-model="model.userName" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="直属领导" hasFeedback>
              <a-input
                id="headName"
                autocomplete="off"
                :allowClear="true"
                :disabled="isEdit"
                v-model="model.fillInUserName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="考核部门" hasFeedback>
              <a-input
                id="deptName"
                autocomplete="off"
                :allowClear="true"
                :disabled="isEdit"
                v-model="model.deptName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="周期类型" hasFeedback>
              <!-- <a-input id="type" autocomplete="off" :allowClear="true" :disabled="isEdit" v-model="model.type" /> -->
              <a-select
                :allowClear="true"
                :disabled="isEdit"
                showSearch
                optionFilterProp="children"
                v-model="model.type"
              >
                <a-select-option v-for="(option, index) in cycleList" :key="index" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="截止日期" hasFeedback>
              <a-date-picker :disabled="isEdit" style="width: 100%" format="YYYY-MM-DD" v-model="model.deadline" />
            </a-form-item> </a-col
          ><a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="填写日期" hasFeedback>
              <a-date-picker format="YYYY-MM-DD" :disabled="isShow" style="width: 100%" v-model="model.fillInTime" />
            </a-form-item> </a-col
          ><a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="考核评分" hasFeedback>
              <a-input
                placeholder="请输入考核评分"
                id="score"
                autocomplete="off"
                :allowClear="true"
                :disabled="isShow"
                v-decorator="['score', { rules: [{ required: true, message: '请输入考核评分！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="考核结果" hasFeedback>
              <a-select
                :allowClear="true"
                placeholder="请选择考核结果"
                :disabled="isShow"
                v-decorator="['scoreLevel', { rules: [{ required: true, message: '请选择考核结果！' }] }]"
              >
                <a-select-option v-for="(item, index) in assessResultList" :key="index" :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="评分附件" hasFeedback required>
              <zm-upload
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                :showUploadList="true"
                acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                @handleUpload="handleUpload"
                :isEdit="isUpload"
                v-show="isZmUpload"
              ></zm-upload>
              <zm-preview
                :list="fileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/user/file/down/"
                v-show="isZmPreview"
              ></zm-preview>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" hasFeedback>
              <a-textarea
                placeholder="请输入"
                :auto-size="{ minRows: 3, maxRows: 3 }"
                :disabled="isShow"
                v-decorator="['remark', { rules: [{ required: true, message: '请输入！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-modal>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { putUserEvaluateOne } from '@/api/assessment'
export default {
  name: 'editAssessment',
  components: {},
  data() {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'assessment' }),
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 },
      },
      colSpan: 12,
      scoreLevelList: [],
      isEdit: true, // 默认一些文本框禁止修改
      isShow: true, // 编辑状态为可修改，查看状态为只读
      cycleList: [
        // 自己定义一个数组去对应接口传过来的值
        {
          name: '第一季度',
          id: 1,
        },
        {
          name: '第三季度',
          id: 3,
        },
        {
          name: '半年度',
          id: 2,
        },
        {
          name: '年度',
          id: 4,
        },
      ],
      headers: {
        // 附件上传的请求头
        Authorization: this.$store.state.user.token,
      },
      fileList: [], // 上传的附件
      footer: true, // 控制对话框的底部按钮的显示
      isUpload: true, // 控制上传组件的上传按钮的显示
      isZmUpload: true, // 控制整个上传组件的显示和隐藏
      isZmPreview: true, // 控制整个预览组件的显示和隐藏
    }
  },
  mounted() {},
  computed: {
    drawerWidth() {
      const width = window.innerWidth - 200
      return width
    },
    ...mapGetters(['assessResultList']),
  },
  methods: {
    // 设置类型
    setType(type) {
      this.type = type
    },
    setTitle(title) {
      // 设置对话框的标题
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      // 得到选择的对应项的数据
      this.model = Object.assign({}, model)
      this.model.deadline = moment(this.model.deadline, 'YYYY-MM-DD')
      this.model.fillInTime = moment(this.model.fillInTime, 'YYYY-MM-DD')
    },
    handleUpload(fileList) {
      // 上传的附件
      this.fileList = fileList
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.visible = flag
      if (flag) {
        if (this.type === this.$sysInfo.MODAL_EDITOR) {
          this.formData()
          this.fileList = this.model.fileList
          this.footer = true
          this.isShow = false
          this.isZmUpload = true
          this.isZmPreview = false
        } else if (this.type === this.$sysInfo.MODAL_VIEW) {
          this.formData()
          this.isShow = true
          this.fileList = this.model.fileList
          this.footer = false
          this.isZmUpload = false
          this.isZmPreview = true
        }
      }
    },
    formData() {
      // 把需要校验的数据放进form里面回显
      this.$nextTick(() => {
        const data = {
          score: this.model.score,
          scoreLevel: this.model.scoreLevel,
          remark: this.model.remark,
        }
        this.form.setFieldsValue(data)
      })
    },
    // 提交表单
    handleSubmit() {
      this.form.validateFieldsAndScroll(async (err, value) => {
        // 表单的默认检验
        if (!err) {
          const params = { ...value }
          console.log(111, params)
          console.log(222, this.model)
          params.fileList = this.fileList // 把上传的文件放进定义的对象里面
          params.id = this.model.id
          params.status = 0 // 点击提交按钮的时候把待考核状态变成已考核
          params.fillInTime = this.model.fillInTime
          // params.scoreLevel = this.model.scoreLevel
          if (params.fileList.length === 0) {
            this.$message.error('请上传相关附件！')
            return
          } else {
            putUserEvaluateOne(params).then((res) => {
              if (res.status === 0) {
                this.$message.success('提交成功')
                this.$emit('refreshTable')
                this.open(false) // 提交成功关闭弹框
              }
            })
          }
        }
      })
    },
    // 清空表单
    formClear() {
      this.$nextTick(() => {
        this.form.resetFields()
        this.$refs.uploader.clearFileList()
      })
    },
    cancel() {
      this.formClear()
      this.open(false)
    },
  },
}
</script>

<style scoped lang="less"></style>
